/**
 * Centralized marketing-site analytics dispatch — fires through whichever
 * tracker is already on the page (Plausible, gtag, PostHog). No-ops if none
 * is present; this never introduces a new tracking dependency. Event name
 * and named props only — never send prompt text or answer content.
 */

import type { AnalyticsEventName } from "./site-config"

type AnalyticsWindow = Window & {
  plausible?: (event: string, opts?: { props?: Record<string, string | number> }) => void
  gtag?: (...args: unknown[]) => void
  posthog?: { capture?: (event: string, props?: Record<string, string | number>) => void }
}

export function fireAnalyticsEvent(name: AnalyticsEventName, props?: Record<string, string | number>) {
  if (typeof window === "undefined") return
  try {
    const w = window as AnalyticsWindow
    if (typeof w.plausible === "function") return w.plausible(name, props ? { props } : undefined)
    if (typeof w.gtag === "function") return w.gtag("event", name, props ?? {})
    if (typeof w.posthog?.capture === "function") return w.posthog.capture(name, props)
  } catch {
    // analytics must never break the page
  }
}
